import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

export const crmRoutes: RouteObject[] = [
  { path: '/crm', lazy: page(() => import('./pages/CustomerListPage.js')) },
  { path: '/crm/customers/:id', lazy: page(() => import('./pages/CustomerDetailPage.js')) },
  { path: '/crm/contacts', lazy: page(() => import('./pages/ContactListPage.js')) },
  // gap-crm-a: 連絡先の名寄せ（重複の疑いのまとまり → まとめて統合）。静的なパスは :id より優先される
  { path: '/crm/contacts/duplicates', lazy: page(() => import('./pages/ContactDuplicatesPage.js')) },
  { path: '/crm/contacts/:id', lazy: page(() => import('./pages/ContactDetailPage.js')) },
  { path: '/crm/cards', lazy: page(() => import('./pages/CardQueuePage.js')) },
  { path: '/crm/cards/:id', lazy: page(() => import('./pages/CardConfirmPage.js')) },
  // 段 5: CSV 取込（導入の入口）と、取引先のカスタム項目の設定
  { path: '/crm/import', lazy: page(() => import('./pages/ImportPage.js')) },
  { path: '/crm/custom-fields', lazy: page(() => import('./pages/CustomFieldsPage.js')) },
  // SFA 1A（SFA機能拡張設計書 §4）: 見込み客・フォーム・見込み客の設定。画面は crm の持ち物だが URL は「営業」（/sales）の配下。
  // このルート配列は crm の ModuleGate の下に置かれるので、crm が無効なら 403（sales は crm に必須依存）
  { path: '/sales/leads', lazy: page(() => import('./pages/leads/LeadListPage.js')) },
  { path: '/sales/leads/:id', lazy: page(() => import('./pages/leads/LeadDetailPage.js')) },
  { path: '/sales/settings/forms', lazy: page(() => import('./pages/leads/LeadFormListPage.js')) },
  { path: '/sales/settings/forms/:id', lazy: page(() => import('./pages/leads/LeadFormEditorPage.js')) },
  { path: '/sales/settings/leads', lazy: page(() => import('./pages/leads/LeadSettingsPage.js')) },
  // SFA 1B（§4・§6.2〜6.4）: メール確認（本人の取り込み候補 → 共有して記録）と会社のメール共有の設定（保存期間）。
  // 権限は画面の中で見る（crm.email.share / crm.email.settings。無ければ「権限がありません」の面）
  { path: '/sales/mail', lazy: page(() => import('./pages/mail/MailReviewPage.js')) },
  { path: '/sales/settings/email', lazy: page(() => import('./pages/mail/EmailSharingSettingsPage.js')) },
];

/**
 * ログイン不要の公開フォーム（§5.1）。URL は ${APP_URL}/f/<publicId>。
 * `apps/web/src/app/router.tsx` で storage の共有リンク（`storagePublicRoutes`）と同じ場所 —
 * PublicOnly / RequireAuth / Shell / ModuleGate の外 — に並べる（サイト訪問者が開く・会社のサイトに埋め込まれる）
 */
export const crmPublicRoutes: RouteObject[] = [{ path: '/f/:publicId', lazy: page(() => import('./pages/leads/PublicLeadFormPage.js')) }];
